import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../features/auth/RequireAuth";
import { BrowseEventsPage } from "../features/events/BrowseEventsPage";

// Behind RequireAuth, matching the `list` rule on public_events (D12). A single
// event stays anonymous at /e/$slug; the catalogue wants a caller.
export const Route = createFileRoute("/events")({
  component: () => (
    <RequireAuth>
      {(user) => (
        <BrowseEventsPage
          uid={user.uid}
          email={user.email}
          signOut={user.signOut}
        />
      )}
    </RequireAuth>
  ),
});
